import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import JobCard from "@/components/JobCard";
import { Input } from "@/components/ui/input";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";
import { MagnifyingGlass } from "@phosphor-icons/react";

const categories = ["Warehousing", "Healthcare", "Hospitality", "Events", "Retail", "Cleaning"];

export default function FindJobs() {
  const [jobs, setJobs] = useState([]);
  const [q, setQ] = useState("");
  const [category, setCategory] = useState("all");
  const [sort, setSort] = useState("recent");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const params = new URLSearchParams();
    if (category !== "all") params.set("category", category);
    params.set("sort", sort);
    api.get(`/jobs?${params.toString()}`).then((r) => {
      setJobs(r.data);
    }).finally(() => setLoading(false));
  }, [category, sort]);

  const filtered = jobs.filter((j) => {
    const s = q.trim().toLowerCase();
    if (!s) return true;
    return [j.title, j.company_name, j.location, j.category].some((x) => (x || "").toLowerCase().includes(s));
  });

  return (
    <div className="space-y-5">
      <div>
        <div className="label-caps">Marketplace</div>
        <h1 className="font-display text-3xl sm:text-4xl font-extrabold text-slate-900">Find your next shift</h1>
      </div>
      <div className="grid md:grid-cols-3 gap-3">
        <div className="relative md:col-span-2">
          <MagnifyingGlass size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
          <Input data-testid="jobs-search-input" placeholder="Search by role, company, location…" value={q} onChange={(e)=>setQ(e.target.value)} className="h-12 pl-9" />
        </div>
        <div className="grid grid-cols-2 gap-2">
          <Select value={category} onValueChange={setCategory}>
            <SelectTrigger data-testid="jobs-category-select" className="h-12"><SelectValue placeholder="Category" /></SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All categories</SelectItem>
              {categories.map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}
            </SelectContent>
          </Select>
          <Select value={sort} onValueChange={setSort}>
            <SelectTrigger data-testid="jobs-sort-select" className="h-12"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="recent">Recently posted</SelectItem>
              <SelectItem value="pay">Highest pay</SelectItem>
              <SelectItem value="date">Earliest date</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>

      {loading ? (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {[1,2,3,4,5,6].map((i) => <div key={i} className="h-40 bg-white border border-slate-200 rounded-md animate-pulse" />)}
        </div>
      ) : filtered.length === 0 ? (
        <div className="text-center py-16 text-slate-500">No jobs match your search.</div>
      ) : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {filtered.map((j) => <JobCard key={j.id} job={j} />)}
        </div>
      )}
    </div>
  );
}
